import React from 'react';

const CrackOverlay = () => {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        backgroundImage: `
          radial-gradient(
            circle at 55% 45%,
            rgba(255,255,255,0.35) 0%,
            rgba(255,255,255,0.18) 6%,
            rgba(255,255,255,0.08) 12%,
            rgba(0,0,0,0.35) 55%,
            rgba(0,0,0,0.55) 100%
          ),
          url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cg stroke='%23ffffff' stroke-width='2' stroke-linecap='round' fill='none' opacity='0.75'%3E%3Cpath d='M520 460 L820 120'/%3E%3Cpath d='M520 460 L940 520'/%3E%3Cpath d='M520 460 L700 820'/%3E%3Cpath d='M520 460 L260 880'/%3E%3Cpath d='M520 460 L120 640'/%3E%3Cpath d='M520 460 L80 320'/%3E%3Cpath d='M520 460 L240 140'/%3E%3Cpath d='M520 460 L520 40'/%3E%3Cpath d='M520 460 L460 760'/%3E%3Cpath d='M600 520 Q640 560 680 600'/%3E%3Cpath d='M460 520 Q420 580 400 640'/%3E%3Cpath d='M540 420 Q600 380 660 360'/%3E%3Cpath d='M480 400 Q420 360 360 340'/%3E%3C/g%3E%3C/svg%3E")
        `,
        backgroundSize: 'cover',
        mixBlendMode: 'overlay',
        filter: 'contrast(1.15) brightness(0.95)',
      }}
    />
  );
};

export default CrackOverlay;
